<template>
  <div class="game-content no-margin">
    <!-- 遮罩开始 -->
    <transition name="fade">
      <em class="mask" v-show="asidePopupState"></em>
    </transition>
    <!-- 遮罩结束 -->

    <!-- 登录窗口开始 -->
    <transition name="fade">
      <template v-if="!isLogin && canShowLoginPannel">
        <template v-if="loginType == 'account'">
          <LoginPopupAccountGlobal
            v-if="isGlobal"
            :disabledAutoLogin="true"
          ></LoginPopupAccountGlobal>
        </template>
      </template>
    </transition>
    <!-- 登录窗口结束 -->

    <!-- 研发游戏界面开始 -->
    <iframe
      v-if="!!decorateGameLink"
      ref="curGamePage"
      id="game-iframe"
      class="iframe j-gamepage-iframe"
      title=""
      :src="decorateGameLink"
      @load="gameLoad"
    ></iframe>
    <!-- 研发游戏界面结束 -->

    <!-- 侧拉栏开始 -->
    <transition name="slide-fade">
      <AsidePopup v-show="asidePopupState">
        <template>
          <AsideUserCenter></AsideUserCenter>
        </template>
      </AsidePopup>
    </transition>
    <!-- 侧拉栏结束 -->

    <!-- 提示框开始 -->
    <transition name="fade">
      <template>
        <TipsCommon v-show="commonTipsContent"></TipsCommon>
      </template>
    </transition>
    <!-- 提示框结束 -->

    <!-- 浮标开始 -->
    <FloatIcon v-if="!!decorateGameLink"></FloatIcon>
    <!-- 浮标结束 -->

    <!-- 弹屏 -->
    <transition name="fade">
      <template v-if="isOpenTca">
        <div v-show="tpShow">
          <TpIframe
            :tpLink="tpLink"
            :tpInitInfo="tpInitInfo"
            @hideTpPopup="hideTp"
            @showTp="showTp"
            :pcIsHorizontal="pcIsHorizontal"
            :mobileIsLandscape="mobileIsLandscape"
          ></TpIframe>
        </div>
      </template>
    </transition>

    <!-- <DanaMaintainPopup></DanaMaintainPopup> -->

    <!-- 授权提示弹窗 -->
    <transition name="fade">
      <DanaGetAuthPopup
        v-if="visibleDanaGetAuthPopup"
        @close="closeDanaGetAuthPopup"
        @goToBind="getDanaAuthCodeForBind"
        @upgradePlatformAccount="upgradePlatformAccount"
      ></DanaGetAuthPopup>
    </transition>

    <!-- tca全局loading -->
    <transition name="fade">
      <div class="loading-mask" v-if="showTcaLoading">
        <div class="load">
          <em class="loading load1"></em>
          <em class="loading load2"></em>
          <em class="loading load3"></em>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import globalConfig from '../utiles/globalConfig'
import Init from '../mixins/Init'
import SdkListener from '../mixins/SdkListener'
import Platform from '../mixins/Platform'
import Tca from '../mixins/Tca'
import Tanping from '../mixins/Tanping'
import AsidePopup from './AsidePopup'
import FloatIcon from './FloatIcon'
import TipsCommon from './commission/TipsCommon'
import AsideUserCenter from './commission/AsideUserCenter'
import LoginPopupAccountGlobal from './commission/LoginPopupAccountGlobal'
import DanaGetAuthPopup from './commission/DanaGetAuthPopup.vue'
// import DanaMaintainPopup from './commission/DanaMaintainPopup.vue'
import TpIframe from './tanping/TpIframe'
import { scrollTop } from '../utiles/index'

export default {
  name: 'DanaIframe',
  mixins: [Init, SdkListener, Platform, Tca, Tanping],
  components: {
    AsidePopup,
    FloatIcon,
    AsideUserCenter,
    LoginPopupAccountGlobal,
    DanaGetAuthPopup,
    // DanaMaintainPopup,
    TpIframe,
    TipsCommon
  },
  data() {
    return {
      loginType: window.pageInfo['loginType'],
      canShowLoginPannel: false
    }
  },
  computed: {
    ...mapGetters([
      'gameLink',
      'asidePopupState',
      'lang',
      'letter',
      'userId',
      'commonTipsContent'
    ]),
    decorateGameLink() {
      if (!this.gameLink) return
      let newGameLink = ''
      const language = globalConfig.getHrefParam('language') || 'en-US'
      try {
        const url = new URL(this.gameLink)
        url.searchParams.append('platform', 'dana')
        url.searchParams.append('language', language || 'en-US')
        newGameLink = url.toString()
      } catch (e) {
        console.error(e)
        newGameLink = `${this.gameLink}&platform=dana&language=${language}`
      }
      return newGameLink
    }
  },
  methods: {
    ...mapActions(['getCurGclid'])
  },
  watch: {
    userId(newV, oldV) {
      if (newV && newV !== oldV) {
        this.getGameLink()
        scrollTop()
        this.getCurGclid().then(() => {
          globalConfig.ajaxStatistics({
            eventName: 'login',
            eventType: 'custom_loss',
            loginAccount: this.userName,
            userId: this.userId,
            gclid: this.gclid,
            cid: this.cid,
            scid: this.scid,
            fbc: this.fbc,
            fbp: this.fbp,
            adid: this.adid,
            adname: this.adname,
            camid: this.camid,
            camname: this.camname,
            adsetid: this.adsetid,
            adsetname: this.adsetname
          })
        })
      }
    }
  },
  async created() {
    const danaAppId = globalConfig.getHrefParam('danaAppId')
    const danaAuthCode = globalConfig.getHrefParam('danaAuthCode')
    this.loadDanaSdk()
    this.onMessageFromDana()
    const isLogin = await this.judgeIsLogin({
      isCheck: true,
      isFirst: false
    })
    const boolAuth = danaAppId && danaAuthCode // danaAppId一定会有，没有授权danaAuthCode为空字符，授权了是个token字符串
    try {
      // 有登录态
      if (isLogin) {
        // 有登录态的并且授权的时候，检查是否绑定dana身份，没有绑定就自动给绑定上
        // 如果【已经授权】&&【游客登录 || 账密登录】&&【没有绑定dana】，则给他自动绑定上
        if (
          boolAuth &&
          (+this.originUserType === 4 || +this.originUserType === 0) &&
          !this.isBindDana
        ) {
          await this.danaBind({
            uid: this.userId,
            danaAppId,
            danaAuthCode
          })
          await this.refreshUserJson()
        }
      }
      // 没有登录态
      else {
        if (boolAuth) {
          // 用户授权了：
          // 如果有uuid说明之前游客登录过，需要使用游客登录，判断是否绑定dana，没有绑定自动绑上
          // 如果没有uuid说明之前没有登录过（或者更新了DANA应用或小程序，会丢失uuid），直接使用dana身份登录
          const danaTouristUUID = window.localStorage.getItem(
            this.LOCAL_STORAGE_DANA_UUID_KEY
          )
          if (danaTouristUUID) {
            await this.touristLoginDana()
            if (!this.isBindDana) {
              await this.danaBind({
                uid: this.userId,
                danaAppId,
                danaAuthCode
              })
              await this.refreshUserJson()
            }
          } else {
            await this.loginDana({
              danaAppId,
              danaAuthCode
            })
          }
        } else {
          // 用户没有授权进行游客登录
          await this.touristLoginDana()
        }
      }
    } catch (e) {
      console.error(e)
    }
    this.canShowLoginPannel = true
  }
}
</script>

<style lang="scss" scoped>
@import url('../assets/scss/gameIframe.scss');
</style>
